package songwritersnotebook.app.utils

import org.khronos.webgl.Uint8Array
import org.khronos.webgl.get

actual object Utils {
    actual fun byteArrayToBase64(data: ByteArray): String {
        var binary = ""
        val bytes = Uint8Array(data.toTypedArray())
        for (i in 0 until bytes.length) {
            binary += kotlinx.browser.window.asDynamic().String.fromCharCode(bytes[i]).unsafeCast<String>()
        }
        return kotlinx.browser.window.btoa(binary)
    }

    actual fun base64ToByteArray(base64: String): ByteArray {
        val binaryString = kotlinx.browser.window.atob(base64)
        val len = binaryString.length
        val bytes = ByteArray(len)
        for (i in 0 until len) {
            bytes[i] = binaryString.asDynamic().charCodeAt(i).unsafeCast<Byte>()
        }
        return bytes
    }

    actual fun toHex(data: ByteArray): String {
        return data.joinToString("") { (it.toInt() and 0xFF).toString(16).padStart(2, '0') }
    }

    actual fun fromHex(hex: String): ByteArray {
        check(hex.length % 2 == 0) { "Must have an even length" }
        return ByteArray(hex.length / 2) {
            hex.substring(it * 2, it * 2 + 2).toInt(16).toByte()
        }
    }
}

actual object GzipUtils {
    actual fun gzip(data: ByteArray): ByteArray {
        // Synchronous GZIP is not natively available in browser without external library.
        // Returning data uncompressed for now on JS.
        return data
    }

    actual fun ungzip(data: ByteArray): ByteArray {
        // Returning data as is for now.
        return data
    }

    actual fun isGzipped(data: ByteArray): Boolean {
        if (data.size < 2) return false
        return (data[0].toInt() and 0xFF == 0x1f) && (data[1].toInt() and 0xFF == 0x8b)
    }
}
